// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as Sentry$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/sentry/Sentry.mjs";
import * as MoEngage$PorterinFeature from "../../utils/moengage/MoEngage.mjs";
import * as AuthUtils$PorterinFeature from "../../../login/domain/helpers/AuthUtils.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as CookieStore$PorterinFeature from "../../utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../utils/browser/CookieUtils.mjs";
import * as CookieConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as MoEngageHelper$PorterinFeature from "../../utils/moengage/MoEngageHelper.mjs";
import * as OrderHistoryVm$PorterinFeature from "../../../order-history/view-model/OrderHistoryVm.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../login/domain/repo/AuthRepoManager.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as OrderHistoryRepoManager$PorterinFeature from "../../../order-history/domian/repo/OrderHistoryRepoManager.mjs";

function getVisitorId(param) {
  var visitorId = CookieHelpers$PorterinUtils.getCookie(CookieStore$PorterinFeature.visitorId);
  if (visitorId === "") {
    return "";
  } else {
    return visitorId;
  }
}

function getGa4ClientId(param) {
  var gaCookie = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.ga_cookie);
  if (gaCookie === "") {
    return "";
  }
  var parts = Js_string.split(".", gaCookie);
  var length = parts.length;
  if (length >= 4) {
    return Caml_array.get(parts, 2) + "." + Caml_array.get(parts, 3);
  } else {
    return "";
  }
}

function fetchProfile(set_user, user, set_is_authenticated, set_is_authenticated_loadable) {
  var match = CookieUtils$PorterinFeature.getAuthCookies(undefined);
  var mobile = match[2];
  var auth_token = match[1];
  var web_tracking_id = match[0];
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  Curry._1(set_is_authenticated_loadable, (function (param) {
          return {
                  TAG: /* Loading */0,
                  _0: true
                };
        }));
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.customerProfile, web_tracking_id, auth_token, mobile);
        }), (function (data) {
          Curry._1(set_user, (function (param) {
                  return {
                          auth_token: auth_token,
                          mobile: data.mobile,
                          name: "" + data.first_name + " " + data.last_name + "",
                          requirement_type: AuthUtils$PorterinFeature.requirementType(user),
                          email: data.mail_info.email,
                          whatsapp_consent: AuthUtils$PorterinFeature.whatsappConsent(user)
                        };
                }));
          if (MoEngage$PorterinFeature.isMoengageObjPresent(undefined) && EventsTrackerHelper$PorterinFeature.isMoengageEnabled(undefined)) {
            MoEngageHelper$PorterinFeature.setMoengageUser({
                  first_name: data.first_name,
                  last_name: data.last_name,
                  email: data.mail_info.email,
                  mobile: data.mobile,
                  customer_uuid: data.customer_uuid,
                  client_id: getGa4ClientId(undefined),
                  session_id: getVisitorId(undefined)
                });
          }
          Curry._1(set_is_authenticated, (function (param) {
                  return true;
                }));
          Curry._1(set_is_authenticated_loadable, (function (param) {
                  return {
                          TAG: /* Live */1,
                          _0: true
                        };
                }));
        }), (function (error) {
          Sentry$PorterinUtils.captureException(ErrorUtils$Catalyst.resolveError(error));
          Curry._1(set_is_authenticated, (function (param) {
                  return false;
                }));
          CookieUtils$PorterinFeature.deleteCookie(CookieStore$PorterinFeature.web_tracking_id);
          CookieUtils$PorterinFeature.deleteCookie("auth-token");
          CookieUtils$PorterinFeature.deleteCookie("mobile");
          Curry._1(set_is_authenticated_loadable, (function (param) {
                  return {
                          TAG: /* Live */1,
                          _0: false
                        };
                }));
        }));
}

function fetchProfileV2(set_user, user, set_is_authenticated, set_is_authenticated_loadable, on_success) {
  var match = CookieUtils$PorterinFeature.getAuthCookies(undefined);
  var mobile = match[2];
  var auth_token = match[1];
  var web_tracking_id = match[0];
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  Curry._1(set_is_authenticated_loadable, (function (param) {
          return {
                  TAG: /* Loading */0,
                  _0: true
                };
        }));
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.customerProfile, web_tracking_id, auth_token, mobile);
        }), (function (data) {
          Curry._1(set_user, (function (param) {
                  return {
                          auth_token: auth_token,
                          mobile: data.mobile,
                          name: "" + data.first_name + " " + data.last_name + "",
                          requirement_type: AuthUtils$PorterinFeature.requirementType(user),
                          email: data.mail_info.email,
                          whatsapp_consent: AuthUtils$PorterinFeature.whatsappConsent(user)
                        };
                }));
          if (MoEngage$PorterinFeature.isMoengageObjPresent(undefined) && EventsTrackerHelper$PorterinFeature.isMoengageEnabled(undefined)) {
            MoEngageHelper$PorterinFeature.setMoengageUser({
                  first_name: data.first_name,
                  last_name: data.last_name,
                  email: data.mail_info.email,
                  mobile: data.mobile,
                  customer_uuid: data.customer_uuid,
                  client_id: getGa4ClientId(undefined),
                  session_id: getVisitorId(undefined)
                });
          }
          Curry._1(on_success, undefined);
          Curry._1(set_is_authenticated, (function (param) {
                  return true;
                }));
          Curry._1(set_is_authenticated_loadable, (function (param) {
                  return {
                          TAG: /* Live */1,
                          _0: true
                        };
                }));
        }), (function (error) {
          Sentry$PorterinUtils.captureException(ErrorUtils$Catalyst.resolveError(error));
          Curry._1(set_is_authenticated, (function (param) {
                  return false;
                }));
          CookieUtils$PorterinFeature.deleteCookie(CookieStore$PorterinFeature.web_tracking_id);
          CookieUtils$PorterinFeature.deleteCookie("auth-token");
          CookieUtils$PorterinFeature.deleteCookie("mobile");
          Curry._1(set_is_authenticated_loadable, (function (param) {
                  return {
                          TAG: /* Live */1,
                          _0: false
                        };
                }));
        }));
}

function fetchOrderHistory(set_order_history) {
  var match = CookieUtils$PorterinFeature.getAuthCookies(undefined);
  var mobile = match[2];
  var auth_token = match[1];
  var web_tracking_id = match[0];
  var RepoInstance = OrderHistoryRepoManager$PorterinFeature.getRepo(undefined);
  Curry._1(set_order_history, (function (param) {
          return {
                  TAG: /* Loading */0,
                  _0: undefined
                };
        }));
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.orderHistory, web_tracking_id, auth_token, mobile);
        }), (function (data) {
          Curry._1(set_order_history, (function (param) {
                  return {
                          TAG: /* Live */1,
                          _0: OrderHistoryVm$PorterinFeature.createVm(data, mobile)
                        };
                }));
        }), (function (error) {
          Sentry$PorterinUtils.captureException(ErrorUtils$Catalyst.resolveError(error));
          Curry._1(set_order_history, (function (param) {
                  return {
                          TAG: /* Error */2,
                          _0: error
                        };
                }));
        }));
}

export {
  getVisitorId ,
  getGa4ClientId ,
  fetchProfile ,
  fetchProfileV2 ,
  fetchOrderHistory ,
}
/* Sentry-PorterinUtils Not a pure module */
